import { LabAppointment } from '../../types/types'
import { formatDateTime } from '../../utils/time.utils'

interface LabAppointmentRowProps {
  labAppointment: LabAppointment
  index: number
}

const LabAppointmentRow: React.FC<LabAppointmentRowProps> = ({
  labAppointment,
  index,
}) => {
  return (
    <tr key={index}>
      <td className="lab-appointment-row-text">{labAppointment.labProvider}</td>
      <td className="lab-appointment-row-text">{labAppointment.labLocation}</td>
      <td className="lab-appointment-row-text">
        {labAppointment.confirmationNumber}
      </td>
      <td className="lab-appointment-row-text">
        {formatDateTime(
          new Date(labAppointment.scheduledAt),
          labAppointment.timezone
        )}
      </td>
      <td className="lab-appointment-row-text">{labAppointment.status}</td>
      <td className="lab-appointment-row-text">
        {labAppointment.cancellationReason === 'other'
          ? `other: ${labAppointment.customCancellationReason}`
          : labAppointment.cancellationReason}
      </td>
    </tr>
  )
}

export default LabAppointmentRow
